var escape = require("../../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bottom-box[data-v-a2ef01a4]{position:fixed;bottom:20px;left:480px;right:480px;height:240px;background:rgba(16,58,68,.6980392157);border:1px solid rgba(68,241,255,.2980392157);-webkit-box-shadow:inset 0 0 142px 0 #06333d;box-shadow:inset 0 0 142px 0 #06333d;padding:10px;border-radius:10px}.bottom-box .cert-item[data-v-a2ef01a4]{-ms-flex-negative:0;flex-shrink:0;padding:6px 8px 10px;background-image:url(" + escape(require("./image/tbg.png")) + ");background-size:100% 100%;background-repeat:no-repeat}.bottom-box .cert-item[data-v-a2ef01a4]:last-child{margin-right:10px}[data-v-a2ef01a4] .el-scrollbar{background:none}", ""]);

// exports
